<template>
  <div class="kpi-punish-page">
    <div v-if="StepList.length === 0" class="empty-data">
      <span>没有相关数据</span>
    </div>
    <div class="bottom-line flex" v-for="(item, index) in StepList">
      <div class="item">
        <img src="https://j.weizan.cn/youxiang/images/stage_img.png" alt />
        <div class="detail">
          <span class="name">{{item.name}}</span>
          <span>
            <span class="tip">开始</span>
            {{item.startTime}}
          </span>
          <span>
            <span class="tip">结束</span>
            {{item.finishTime}}
          </span>
        </div>
      </div>
      <div class="btn">
        <van-button type="info" size="small" round @click="editStage(item.id)">奖惩任务分配 ></van-button>
      </div>
    </div>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      user: null,
      kpi_user: null,
      stages: [],
      loaded: false,
      StepList: [],
    };
  },
  created() {
    // this.getSteps();
    // this.getUser();
    this.getQueryStepList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    async getQueryStepList() {
      let res = await this.$http.post("/v1/taskmanage/query_step_list");
      console.log(res);
      if (res.data && res.code == 0) {
        this.StepList = res.data.list;
      }
    },
    editStage(stepId) {
      this.$router.push({
        name: "kpi.basic.tasks",
        query: {
          step_id: stepId,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    getSteps() {
      const json = {
        activity_id: this.activity.id,
      };
      this.$fn.showLoading();
      this.$fn.get("steps", json, (res) => {
        this.$fn.closeLoading();
        if (res.status !== "success") {
          this.loaded = true;
          return;
        }
        this.stages = res.data;
        this.loaded = true;
      });
    },
    goBasicTasks(item) {
      this.$router.push({
        name: "kpi.basic.tasks",
        params: { step_id: item.id },
        query: {
          activity_id: this.activity.id,
          user_id: this.user_id,
          kpi_uid: this.kpi_uid,
          share_uid: this.share_uid,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    /**
     * 获取用户信息
     */
    getUser() {
      this.$fn.get("user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "success") {
          this.user = res.data;
        }
        this.getKpiUser();
      });
    },
    getKpiUser() {
      this.$fn.get("kpi/user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "success") {
          this.kpi_user = res.data; // type: 3--导购员  type: 2--品牌负责人 type: 1--活动负责人
        }
        this.$fn.commonShare(this.activity, this.user, this.kpi_user);
      });
    },
  },
};
</script>

<style lang="less">
.kpi-punish-page {
  .flex {
    background-color: #ffffff;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 45px;
        min-width: 45px;
        max-width: 45px;
        height: 45px;
        border-radius: 50%;
        vertical-align: bottom;
      }
      .detail {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        font-size: 12px;
        .name {
          color: #5293fd;
          font-size: 14px;
          margin-bottom: 5px;
        }
        .tip {
          color: #999999;
          margin-right: 3px;
        }
      }
    }
  }
  .van-button--small {
    height: 26px;
    line-height: 24px;
  }
}
</style>
